import React, { useState } from 'react';
import axios from 'axios';
import { toast } from '../../components/notifications/notificationService';
import './ClientPOSPage.css';
import { API_BASE_URL } from '../../utils/apiBase';

const ClientPOSPage = () => {
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        phoneNumber: '',
        insuranceTypes: [],
        pinCode: ''
    });
    const [posList, setPosList] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 5; // Show 5 POS per page
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = posList.slice(indexOfFirstEntry, indexOfLastEntry);

    const totalPages = Math.ceil(posList.length / entriesPerPage);

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            const updatedTypes = checked
                ? [...formData.insuranceTypes, value]
                : formData.insuranceTypes.filter((type) => type !== value);
            setFormData({ ...formData, insuranceTypes: updatedTypes });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${API_BASE_URL}/api/pos/saveClientData`, formData);

            toast.success('Client data submitted successfully!');

            // After submission, fetch matching POS list
            const response = await axios.get(`${API_BASE_URL}/api/pos/allPos`);
            const filteredPOS = response.data
                .filter(pos => pos.posPinCode === formData.pinCode)
                .sort((a, b) => a.posName.localeCompare(b.posName));

            setPosList(filteredPOS);
            setSubmitted(true);
        } catch (error) {
            console.error('Error submitting client data:', error);
            toast.error('Failed to submit client data.');
        }
    };

    const closePopup = () => {
        setShowForm(false);
        setFormData({
            name: '',
            phoneNumber: '',
            insuranceTypes: [],
            pinCode: ''
        });
        setPosList([]);
        setSubmitted(false);
    };

    return (
        <div className="client-page">
            <button onClick={() => setShowForm(true)} className="open-form-button">
                Personal Advisor
            </button>

            {showForm && (
                <div className="modal">
                    <div className="modal-content">
                        {!submitted ? (
                            <>
                                <h2 className="form-heading">Enter Client Details</h2>

                                <form onSubmit={handleSubmit} className="client-form">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Enter Name"
                                            value={formData.name}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Phone Number</label>
                                        <input
                                            type="text"
                                            name="phoneNumber"
                                            placeholder="Enter Phone Number"
                                            value={formData.phoneNumber}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Insurance Types</label>
                                        <div className="checkbox-group">
                                            <label className="checkbox-label">
                                                <input
                                                    type="checkbox"
                                                    name="insuranceTypes"
                                                    value="Motor"
                                                    onChange={handleFormChange}
                                                /> Motor
                                            </label>

                                            <label className="checkbox-label">
                                                <input
                                                    type="checkbox"
                                                    name="insuranceTypes"
                                                    value="Health"
                                                    onChange={handleFormChange}
                                                /> Health
                                            </label>

                                            <label className="checkbox-label">
                                                <input
                                                    type="checkbox"
                                                    name="insuranceTypes"
                                                    value="Life"
                                                    onChange={handleFormChange}
                                                /> Life
                                            </label>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label>Pin Code</label>
                                        <input
                                            type="text"
                                            name="pinCode"
                                            placeholder="Enter Pin Code"
                                            value={formData.pinCode}
                                            onChange={handleFormChange}
                                            required
                                        />
                                    </div>

                                    <button type="submit" className="submit-button">Submit</button>
                                </form>
                            </>
                        ) : (
                            <>
                                <h3>POS List for Pin Code {formData.pinCode}</h3>
                                {posList.length > 0 ? (
                                    <table className="pos-table">
                                        <thead>
                                            <tr>
                                                <th>Profile</th>
                                                <th>Name</th>
                                                <th>Phone Number</th>
                                                <th>Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentEntries.map(pos => (
                                                <tr key={pos._id}>
                                                    <td>
                                                        <img
                                                            src={`${API_BASE_URL}/api/pos/photo/${pos._id}`}
                                                            alt="Profile"
                                                            width="50"
                                                            height="50"
                                                            style={{ borderRadius: '50%' }}
                                                            onError={(e) => { e.target.onerror = null; e.target.src = '/no-profile.png'; }}
                                                        />

                                                    </td>
                                                    <td>{pos.posName}</td>
                                                    <td>
                                                        <div className="phone-whatsapp-wrapper">
                                                            <span className="phone-text">{pos.posPhoneNumber}</span>
                                                            <a
                                                                href={`https://wa.me/${pos.posPhoneNumber}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                title="Message on WhatsApp"
                                                                className="whatsapp-icon-link"
                                                            >
                                                                <img
                                                                    src="/whatsapp-icon.svg"
                                                                    alt="WhatsApp"
                                                                    width="20"
                                                                    height="20"
                                                                    className="whatsapp-icon"
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = '/no-profile.png'; }}
                                                                />
                                                            </a>
                                                        </div>
                                                    </td>


                                                    <td>{pos.posAddress}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                ) : (
                                    <p>No POS found for this Pin Code</p>
                                )}
                            </>
                        )}
                        {submitted && posList.length > 0 && (
                            <div className="pagination-controls">
                                <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                    Previous
                                </button>
                                <span> Page {currentPage} of {totalPages} </span>
                                <button onClick={goToNextPage} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                            </div>
                        )}


                        <button onClick={closePopup}>Close</button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default ClientPOSPage;
